import { Link } from "react-router-dom";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-xl mx-auto px-6 py-12">
      <header>
        <h1 className="font-bold text-3xl">About WanCo</h1>
        <p className="font-mono90 text-sm mt-2">
          [ <Link data-testid="nav-home-link" to="/">back to homepage</Link> ] [ <Link data-testid="nav-apps-link" to="/apps">apps</Link> ]
        </p>
      </header>

      <hr className="hr90" />

      <section data-testid="about-content">
        <p className="text-lg leading-relaxed">
          Hi, I'm the person behind WanCo Industries.
        </p>
        <p className="text-lg leading-relaxed mt-4">
          I make applications that I believe should exist. Sometimes an idea
          just won't leave me alone — an app I keep wishing was on my phone
          but isn't. So I build it.
        </p>
        <p className="text-lg leading-relaxed mt-4">
          And once it exists, I want others to enjoy it too. That's the whole
          philosophy: build the things that should be out there, then share
          them with anyone who might love them as much as I do.
        </p>
        <p className="text-lg leading-relaxed mt-4">
          If that sounds like your kind of thing, <a data-testid="about-contact-link" href="/#contact">say hello</a>.
        </p>
      </section>

      <hr className="hr90" />

      <footer className="font-mono90 text-xs">
        <p>&copy; 2026 WanCo Industries</p>
      </footer>
    </div>
  );
}
